import { StoryCardType } from '../../../../../services';
import {
  EventPostFields,
  FullPostFields,
  LinkPostFields,
  PollPostFields,
  ShortPostFields,
  ThreadPostFields,
} from '../CreateCardModal';
import { galleryMap } from './galleryMap';

interface GetFieldsByStoryCardTypeArgs {
  shortPostFields: ShortPostFields;
  fullPostFields: FullPostFields;
  linkPostFields: LinkPostFields;
  threadPostFields: ThreadPostFields;
  pollPostFields: PollPostFields;
  eventPostFields: EventPostFields;
  postInCardType?: StoryCardType;
  backgroundColor?: string;
}

const getArticleFields = (linkPostFields: LinkPostFields) => {
  const { url, article } = linkPostFields;

  if (!article) {
    return;
  }

  const { type, urlFormatted, gallery, ...rest } = article;

  return { articleFields: { ...rest, url, gallery: galleryMap(gallery) } };
};

const getQuoteFields = (linkPostFields: LinkPostFields) => {
  const { url, quote } = linkPostFields;

  if (!quote) {
    return;
  }

  const { type, quotePersonImage, gallery, ...rest } = quote;

  return {
    quoteFields: {
      ...rest,
      url,
      gallery: galleryMap(gallery),
      ...(quotePersonImage?.id && { quotePersonImageId: quotePersonImage.id }),
    },
  };
};

export const getFieldsByStoryCardType = ({
  shortPostFields,
  fullPostFields,
  linkPostFields,
  threadPostFields,
  pollPostFields,
  eventPostFields,
  postInCardType,
  backgroundColor,
}: GetFieldsByStoryCardTypeArgs) => {
  const { gallery, ...shortPostRest } = shortPostFields;

  const mediaFields = { ...shortPostRest, gallery: galleryMap(gallery) };

  const postFields = () => {
    switch (postInCardType) {
      case StoryCardType.EDITORIAL: {
        const { gallery, ...editorialFields } = mediaFields;

        return { editorialFields };
      }
      case StoryCardType.IMAGE:
        return { imageFields: mediaFields };
      case StoryCardType.AUDIO:
        return { audioFields: mediaFields };
      case StoryCardType.VIDEO:
        return { videoFields: mediaFields };
      case StoryCardType.PDF:
        return { pdfFields: mediaFields };
      case StoryCardType.POST: {
        const { gallery, ...postFields } = fullPostFields;

        return { postFields: { ...postFields, gallery: galleryMap(gallery) } };
      }
      case StoryCardType.THREAD:
        return { threadFields: threadPostFields };
      case StoryCardType.ARTICLE:
        return getArticleFields(linkPostFields);
      case StoryCardType.QUOTE:
        return getQuoteFields(linkPostFields);
      case StoryCardType.POLL: {
        const { totalVotes, gallery, ...pollFields } = pollPostFields;

        return { pollFields: { ...pollFields, gallery: galleryMap(gallery) } };
      }
      case StoryCardType.EVENT:
        return { eventFields: { headline: eventPostFields.headline } };
    }
  };

  const fields = postFields();

  if (!fields) {
    return;
  }

  const key = Object.keys(fields)[0];

  const value = Object.values(fields)[0] as Record<string, unknown>;

  return {
    [key]: { ...value, styles: { ...(value.styles as object | undefined), backgroundColor } },
  };
};
